const state = {
    sideMenu: 'info'
}


export default state


// WEBPACK FOOTER //
// ./src/store/state.js